import { connectApi } from "@api/coreApi";
import { baseURL } from "@api/endpoints";

export const getOfferList = () =>
  connectApi({
    method: "GET",
    url: `${baseURL.getOfferList}`,
  });

export const getOfferDetail = ({ redeem_id }) =>
  connectApi({
    method: "GET",
    url: `${baseURL.getOfferDetail}?redeem_id=${redeem_id}`,
  });

export const submitRedeemOffer = (payload) =>
  connectApi({
    method: "POST",
    url: baseURL.submitRedeemOffer,
    payload,
  });

  export const submitConvertRewards = (payload) =>
    connectApi({
      method: "POST",
      url: baseURL.submitConvertRewards,
      payload,
    });
  